import '@plone/components/dist/basic.css';
import Card from '../Card/View';
import markphoto from '../../../../images/mark.jpeg';
import carlosphoto from '../../../../images/carlos-perez.jpg';
import yolandaphoto from '../../../../images/Yolanda.jpg';
import omairaphoto from '../../../../images/omaira2.jpeg';
import { Image } from '@plone/volto/components';

const cardData = [
  {
    icon: (
      <Image style={{ borderRadius: '50%', width: '30%' }} src={markphoto} />
    ),
    description:
      ' “La precisión de las emisiones de contaminantes atmosféricos que obtendremos permitirá, no solo mejorar el modelado de la calidad del aire en España, sino también respaldar aplicaciones en salud pública y gestión ambiental”.',
    personName: 'Marc Guevara',
    position: 'Coordinador científico del proyecto',
  },

  {
    icon: (
      <Image style={{ borderRadius: '50%', width: '30%' }} src={yolandaphoto} />
    ),
    description:
      '"Gracias a los fondos del Plan de Recuperación, Transformación y Resiliencia (PRTyR), se ha podido articular una colaboración con el BSC cuyos resultados serán un ejemplo exitoso de cooperación entre un centro público operativo como AEMET, y un centro público de supercomputación, como el BSC"',
    personName: 'Yolanda Luna Rico',
    position: 'Jefa depto. de Desarrollo y Aplicaciones de AEMET',
  },
  {
    icon: (
      <Image style={{ borderRadius: '50%', width: '30%' }} src={carlosphoto} />
    ),
    title: 'Sistemas de emisiones',
    description:
      '“Con este proyecto,  España aumentará sus capacidades estratégicas de predicción y monitorización de contaminantes atmosféricos y gases de efecto invernadero, permitiendo una mejor toma de decisiones para su control y contribuyendo a los esfuerzos internacionales de mitigación del cambio climático”',
    personName: 'Carlos Pérez García-Pando',
    position: 'Jefe de grupo de investigación BSC',
  },

  {
    icon: (
      <Image style={{ borderRadius: '50%', width: '30%' }} src={omairaphoto} />
    ),
    description:
      '"RESPIRE supone un hito en la estrategia nacional para la monitorización precisa de la contaminación atmosférica y los principales gases de efecto invernadero, elementos clave en el calentamiento global. La centralización de la información que nos permitirá este portal RESPIRE ayudará a comprender mejor nuestra situación actual y a una toma de decisiones eficaces"',
    personName: 'Omaira García Rodríguez',
    position: 'Coordinadora de COCCON-España',
  },
];

const isImageCard = true;

const CardGrid = () => {
  return (
    <>
      <div className="background-grey">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '1.7em',
            color: '#00a3a8',
            fontWeight: '600',
          }}
        >
          Lo que dicen nuestros expertos
        </div>
        <div className="testimonial-grid">
          {cardData.map((card, index) => (
            <div className="card-grid-item" key={index}>
              <Card
                icon={card.icon}
                title={card.title}
                description={card.description}
                isImageCard={isImageCard}
                personName={card.personName}
                position={card.position}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CardGrid;
